import React from 'react';
import {
	makeStyles,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
} from '@material-ui/core';
import { formatDate } from '@/services/utils/date-time';
import { CustomerDocumentModel } from '@/models/customer';

const useStyles = makeStyles(() => ({
	paper: {
		padding: '20px',
		marginBottom: '30px',
	},
	table: {
		minWidth: 650,
	},
}));

const DATETIME_FORMAT = 'dd.MM.yyyy';

interface Props {
	customerDocuments?: CustomerDocumentModel[]
}

export const Documents = (props: Props) => {
	const classes = useStyles();

	return (
		<Paper component="ul" className={classes.paper}>
			<Typography variant="h4" component="h4">Documents</Typography>
			{props.customerDocuments?.length
				?
				<TableContainer component={Paper}>
					<Table data-name="documents" className={classes.table} aria-label="simple table">
						<TableHead>
							<TableRow>
								<TableCell>Type</TableCell>
								<TableCell align="right">Number</TableCell>
								<TableCell align="right">Expiration Date</TableCell>
								<TableCell align="right">Issuing Date</TableCell>
								<TableCell align="right">Issuing Country Code</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{ props.customerDocuments?.map((document) => {
								const expirationDate = document.expirationDate ? formatDate(document.expirationDate, DATETIME_FORMAT) : 'Invalid date';
								const issuingDate = document.issuingDate ? formatDate(document.issuingDate, DATETIME_FORMAT) : 'Invalid date';

								return (
									<TableRow key={document.id}>
										<TableCell component="td" scope="row">
											{document.type}
										</TableCell>
										<TableCell align="right">{document.number}</TableCell>
										<TableCell align="right">{expirationDate}</TableCell>
										<TableCell align="right">{issuingDate}</TableCell>
										<TableCell align="right">{document.issuingCountryCode}</TableCell>
									</TableRow>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>

				: <span>No documents found</span>
			}

		</Paper>
	);
};
